import { formatValue as valueFormatter, getFromPath, } from '@keen.io/charts-utils';
var getLabel = function (_a) {
    var _b = _a.isPercentage, isPercentage = _b === void 0 ? false : _b, selector = _a.selector, data = _a.data, percentageData = _a.percentageData, formatValue = _a.formatValue;
    var value = valueFormatter(getFromPath(data, selector), formatValue);
    if (isPercentage) {
        return {
            value: getFromPath(percentageData, selector).toFixed(1) + "%",
            change: "(" + value + ")",
        };
    }
    return { value: value };
};
export default getLabel;
